import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div>
        <footer id="site-footer">
          <a className="sponsor" href="http://offtoneverland.com/?cpe=Y3A9R2VuZXJhbCtMaW5rJnM9RC1Db1Q%3D" target="_blank" rel="noopener noreferrer">
            <img className="img-fluid" alt="Off to Neverland Travel" src="https://jukebox.d-cot.com/static/media/offtoneverland.0281f8ca.jpg" />
          </a>

          <div className="container">
            <ul>
              <li><a href="https://www.d-cot.com/become-a-supporter/" target="_blank" rel="noopener noreferrer">Become A Supporter</a></li>
              <li><a href="https://www.d-cot.com/become-a-sponsor/" target="_blank" rel="noopener noreferrer">Become A Sponsor</a></li>
              <li><a href="https://www.d-cot.com/blog/" target="_blank" rel="noopener noreferrer">Blog</a></li>
              <li><a href="https://www.d-cot.com/contact-us/" target="_blank" rel="noopener noreferrer">Contact</a></li>
              <li><a href="https://www.d-cot.com/become-a-supporter/" target="_blank" rel="noopener noreferrer">FAQ</a></li>
              <li><a href="https://www.d-cot.com/terms-of-use-privacy-policy/" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
              <li><a href="https://www.d-cot.com/terms-of-use-privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              <li><a href="https://www.d-cot.com/cookie-policy/" target="_blank" rel="noopener noreferrer">Cookie Policy</a></li>
            </ul>
            <p className="small">D-COT &copy; 2021. D-COT.com is not affiliated with The Walt Disney Company. All Disney films, characters, theme parks, attractions, names, etc. are registered trademarks and/or copyrights of The Walt Disney Company and/or its subsidiaries and/or affiliates. In no instance does D-COT.com imply ownership and/or interest in any of the copyrighted/trademarked/intellectual property rights affiliated with The Walt Disney Company and/or their subsidiaries and/or affiliates. D-COT serves the purpose of a fan site only and is a production of MixxCreative LLC.</p>
          </div>
        </footer>

        <div id="modal" className="modal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">&nbsp;</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">&nbsp;</div>
              <div className="modal-footer">&nbsp;</div>
            </div>
          </div>
        </div>

        <div aria-live="polite" aria-atomic="true" className="toasty d-flex justify-content-center align-items-center">
          <div id="toast" className="toast" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header">
              <strong className="mr-auto toast-title">&nbsp;</strong>
              <small>&nbsp;</small>
              <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="toast-body">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
